import { render, staticRenderFns } from "./PlanCreate.vue?vue&type=template&id=5bdbeec8&scoped=true"
import script from "./PlanCreate.vue?vue&type=script&lang=js"
export * from "./PlanCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdbeec8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/crm1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bdbeec8')) {
      api.createRecord('5bdbeec8', component.options)
    } else {
      api.reload('5bdbeec8', component.options)
    }
    module.hot.accept("./PlanCreate.vue?vue&type=template&id=5bdbeec8&scoped=true", function () {
      api.rerender('5bdbeec8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/crm/receivables/PlanCreate.vue"
export default component.exports